angular
	.module 'App.Module.Login', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'about',
				url: '/about'
				views:
					main:
						templateUrl: '@app/login/login/login.about.view.html'
						controller: (ALLOW_SELF_REGISTRATION, TERMS_URL, EXTERNAL_REGISTRATION_URL) ->
							@ALLOW_SELF_REGISTRATION = ALLOW_SELF_REGISTRATION
							@EXTERNAL_REGISTRATION_URL = EXTERNAL_REGISTRATION_URL
							@TERMS_URL = TERMS_URL
						controllerAs: 'vm'
				data:
					require_login: false
					pageTitle: 'About'
					hideMenu: true
					hideSubMenu: true
					showFooter: false

			.state 'login',
				url: '/login?section'
				views:
					main:
						templateUrl: '@app/login/login.view.html'
						controllerAs: 'vm'
						controller: ($scope, $stateParams, ALLOW_SELF_REGISTRATION, EXTERNAL_REGISTRATION_URL, TERMS_URL) ->
							@ALLOW_SELF_REGISTRATION = ALLOW_SELF_REGISTRATION
							@EXTERNAL_REGISTRATION_URL = EXTERNAL_REGISTRATION_URL
							@TERMS_URL = TERMS_URL
							@section = $stateParams.section ? 'login'

							$scope.$on 'registration', =>
								@section = 'login'

							return
					'main.login-view':
						controller: 'LoginController'
						controllerAs: 'login'
						templateUrl: '@app/login/login/login.view.html'
					'main.sign-up-view':
						controller: 'SignUpController'
						controllerAs: 'signUp'
						templateUrl: '@app/login/sign-up/sign-up.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					countries: (PublicRepository, ALLOW_SELF_REGISTRATION) ->
						if !ALLOW_SELF_REGISTRATION
							return []

						query = do PublicRepository.createQuery
						query.sortBy 'name', 'ASC'
						query.with 'licenses'

						return PublicRepository
							.getCountries(query)
							.then (response) =>
								return _.reject response.data, (country) => country.licenses.length == 0
				data:
					require_login: false
					pageTitle: 'Login'
					hideMenu: true
					hideSubMenu: true
					showFooter: false

			.state 'login.identifier',
				url: '/:identifier'
				data:
					pageTitle: 'Login'

			.state 'logout',
				url: '/logout',
				resolve:
					logout: (AuthenticationService) ->
						AuthenticationService.logout()
